import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { ThemeContext } from "../../ThemeProvider";

const MyHeader = () => {
  const { isDarkTheme, toggleTheme } = useContext(ThemeContext);
  const location = useLocation();

  return (
    <div className="header">
      <div className="headerLinks">
        <Link className="footerLink" onClick={toggleTheme}>
          {isDarkTheme ? "Light Theme" : "Dark Theme"}
        </Link>
        {location.pathname !== "/" && (
          <Link className="footerLink" to="/">
            Home
          </Link>
        )}
        {location.pathname !== "/imprint" && (
          <Link className="footerLink" to="/imprint">
            Imprint
          </Link>
        )}
        {location.pathname !== "/privacy" && (
          <Link className="footerLink" to="/privacy">
            Privacy
          </Link>
        )}
      </div>
      <div className="copyrightNotice">
        © {new Date().getFullYear()} Matteo Rosoli. All rights reserved.
      </div>
    </div>
  );
};

export default MyHeader;
